import scoreTimelines from "./score-timelines.json" with { type: "json" };
import { nbaVisualFixtures } from "./nba-visual-fixtures.ts";
import { regularSeasonSources } from "./source-fixtures.ts";
const clock = (period, periodLabel, displayClock) => ({
    period,
    periodLabel,
    displayClock
});
export const regularSeasonScenario = {
    id: "0022500641",
    label: "Pacers at Thunder",
    shortLabel: "IND · OKC",
    competition: "NBA Regular Season",
    venue: "Paycom Center · Oklahoma City",
    scheduledAt: "2026-01-24T01:00:00Z",
    replayDurationMs: 180_000,
    periodLengthSeconds: 720,
    awayTeam: {
        id: "pacers",
        city: "Indiana",
        name: "Pacers",
        abbreviation: "IND",
        color: "#002D62",
        contrastColor: "#FDBB30"
    },
    homeTeam: {
        id: "thunder",
        city: "Oklahoma City",
        name: "Thunder",
        abbreviation: "OKC",
        color: "#007AC1",
        contrastColor: "#F05133"
    },
    replayAnchors: [
        { replayAtMs: 0, period: 1, clockSeconds: 720 },
        { replayAtMs: 4_000, period: 1, clockSeconds: 720 },
        { replayAtMs: 36_000, period: 1, clockSeconds: 0 },
        { replayAtMs: 72_000, period: 2, clockSeconds: 0 },
        { replayAtMs: 112_000, period: 3, clockSeconds: 0 },
        { replayAtMs: 150_000, period: 4, clockSeconds: 201 },
        { replayAtMs: 156_000, period: 4, clockSeconds: 133 },
        { replayAtMs: 170_000, period: 4, clockSeconds: 24.3 },
        { replayAtMs: 180_000, period: 4, clockSeconds: 0 }
    ],
    scoreEvents: scoreTimelines.games["0022500641"].events,
    storyBeats: [
        { replayAtMs: 0, text: "A Finals rematch is next in Oklahoma City." },
        { replayAtMs: 4_000, text: "The rematch begins with both teams hunting an early edge." },
        { replayAtMs: 12_800, text: "Nembhard is setting the pace for Indiana." },
        { replayAtMs: 36_000, text: "Indiana's 39-point first quarter has changed the temperature." },
        { replayAtMs: 44_850, text: "Nembhard's third three stretches Indiana's lead to 17." },
        { replayAtMs: 62_350, text: "Oklahoma City has turned 17 points into seven." },
        { replayAtMs: 72_000, text: "Oklahoma City has cut a 17-point gap to five." },
        { replayAtMs: 82_834, text: "Holmgren blocks two shots, then scores to make it one possession." },
        { replayAtMs: 87_111, text: "Gilgeous-Alexander's and-one keeps the Thunder within one possession." },
        { replayAtMs: 95_112, text: "Walker is building a career night as Indiana answers every push." },
        { replayAtMs: 102_556, text: "Gilgeous-Alexander has 32 and Oklahoma City is within three." },
        { replayAtMs: 112_000, text: "Holmgren gets it to one; Potter answers before the quarter ends." },
        { replayAtMs: 137_041, text: "Nembhard's tenth assist takes Indiana to 100." },
        { replayAtMs: 156_000, text: "Nembhard's fourth three gives Indiana a ten-point cushion." },
        { replayAtMs: 163_857, text: "Gilgeous-Alexander's three-point play keeps the Thunder alive." },
        { replayAtMs: 170_000, text: "Gilgeous-Alexander has dragged the Thunder within one." },
        { replayAtMs: 175_762, text: "Walker makes both. Indiana leads by three." },
        { replayAtMs: 177_531, text: "SGA answers; Walker answers back. Six seconds remain." },
        { replayAtMs: 180_000, text: "Indiana survives the final Thunder charge." }
    ],
    evidenceEvents: [
        {
            id: "rematch-pregame",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "12:00"),
            kind: "media",
            facts: ["Indiana and Oklahoma City were set for a regular-season Finals rematch, with Oklahoma City's official account sharing a warm-up photo collage before tip."],
            sourceRefs: ["NBA game 0022500641", "X 2014855979242860742"]
        },
        {
            id: "regular-game-context",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "12:00"),
            kind: "stat",
            facts: ["Paycom Center hosted Indiana and Oklahoma City, with local television coverage and SiriusXM radio."],
            sourceRefs: ["NBA game 4b42af578776"]
        },
        {
            id: "regular-availability",
            replayAtMs: 0,
            clock: clock(1, "Pregame", "12:00"),
            kind: "stat",
            facts: ["The pregame roster record listed Tyrese Haliburton and Bennedict Mathurin inactive because of injury, alongside multiple Oklahoma City absences."],
            sourceRefs: ["NBA roster 5d507fb5ab30"]
        },
        {
            id: "rematch-tip",
            replayAtMs: 4_000,
            clock: clock(1, "1st", "12:00"),
            kind: "media",
            facts: ["Indiana and Oklahoma City met in a regular-season Finals rematch."],
            sourceRefs: ["NBA game 0022500641"]
        },
        {
            id: "nembhard-seven",
            replayAtMs: 12_800,
            clock: clock(1, "1st", "8:42"),
            kind: "stat",
            facts: ["Andrew Nembhard scored seven of Indiana's first 11 points."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "pacers-first-quarter",
            replayAtMs: 36_000,
            clock: clock(1, "End 1st", "0:00"),
            kind: "score",
            facts: ["Indiana led 39–28 after the first quarter."],
            sourceRefs: ["NBA box score", "X 2014876797825884484"]
        },
        {
            id: "regular-second-quarter-open",
            replayAtMs: 37_000,
            clock: clock(2, "2nd", "11:40"),
            kind: "score",
            facts: ["Indiana opened the second quarter with a 39–28 lead."],
            sourceRefs: ["NBA play-by-play 4b26b9387408"]
        },
        {
            id: "nembhard-sixteen",
            replayAtMs: 44_850,
            clock: clock(2, "2nd", "9:03"),
            kind: "milestone",
            facts: ["Nembhard's third three gave him 16 points and Indiana a 47–30 lead."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "wallace-cuts-to-seven",
            replayAtMs: 62_350,
            clock: clock(2, "2nd", "3:13"),
            kind: "run",
            facts: ["Cason Wallace's three completed a 16–6 Thunder response and cut Indiana's lead to 53–46."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "halftime-close",
            replayAtMs: 72_000,
            clock: clock(2, "Halftime", "0:00"),
            kind: "run",
            facts: ["Oklahoma City reduced a 17-point deficit to 58–53 at halftime."],
            sourceRefs: ["NBA play-by-play", "NBA owned social video"]
        },
        {
            id: "regular-end-second",
            replayAtMs: 72_000,
            clock: clock(2, "End 2nd", "0:00"),
            kind: "score",
            facts: ["Oklahoma City won the second quarter 25–19, but Indiana led 58–53 at the horn."],
            sourceRefs: ["NBA box score 5261fe267ff3", "NBA play-by-play 4b26b9387408"]
        },
        {
            id: "regular-third-quarter-open",
            replayAtMs: 73_111,
            clock: clock(3, "3rd", "11:40"),
            kind: "score",
            facts: ["Indiana opened the third quarter ahead 58–53."],
            sourceRefs: ["NBA play-by-play 4b26b9387408"]
        },
        {
            id: "chet-two-way-sequence",
            replayAtMs: 82_834,
            clock: clock(3, "3rd", "8:45"),
            kind: "run",
            facts: [
                "Chet Holmgren blocked consecutive Pacers shots one second apart, then scored at the other end to cut Indiana's lead to 63–60."
            ],
            sourceRefs: ["NBA play-by-play 4b26b9387408 actions 397–406"]
        },
        {
            id: "walker-fifteen",
            replayAtMs: 95_112,
            clock: clock(3, "3rd", "5:04"),
            kind: "stat",
            facts: ["Jarace Walker's third three gave him 15 points and Indiana a 78–69 lead."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "sga-thirty-two",
            replayAtMs: 102_556,
            clock: clock(3, "3rd", "2:50"),
            kind: "stat",
            facts: [
                "Gilgeous-Alexander's and-one at 7:28 made it 68–65; he later reached 32 points and again cut the deficit to three at 82–79."
            ],
            sourceRefs: ["NBA play-by-play 4b26b9387408 actions 424–427"]
        },
        {
            id: "four-point-lead",
            replayAtMs: 112_000,
            clock: clock(3, "End 3rd", "0:00"),
            kind: "score",
            facts: [
                "Holmgren cut Indiana's lead to one with 33.7 seconds left, and Potter answered with a three 15.7 seconds later before Indiana led 89–85 at the horn."
            ],
            sourceRefs: ["NBA box score", "NBA play-by-play 4b26b9387408 actions 519–521"]
        },
        {
            id: "regular-fourth-quarter-open",
            replayAtMs: 113_465,
            clock: clock(4, "4th", "11:40"),
            kind: "score",
            facts: ["Indiana opened the fourth quarter with an 89–85 lead."],
            sourceRefs: ["NBA play-by-play 4b26b9387408"]
        },
        {
            id: "regular-second-unit-five",
            replayAtMs: 112_000,
            clock: clock(3, "End 3rd", "0:00"),
            kind: "stat",
            facts: [
                "Nembhard, Nesmith, Potter, Walker and Sheppard scored 12 points in 2.5 minutes together, shooting 5-for-5 and finishing plus-6."
            ],
            sourceRefs: ["NBA lineup box b88547affef5"]
        },
        {
            id: "pacers-one-hundred",
            replayAtMs: 137_041,
            clock: clock(4, "4th", "6:18"),
            kind: "milestone",
            facts: ["Walker dunked on Nembhard's tenth assist to give Indiana a 100–91 lead."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "nembhard-three",
            replayAtMs: 156_000,
            clock: clock(4, "4th", "2:13"),
            kind: "milestone",
            facts: ["Andrew Nembhard's fourth three put Indiana ahead 113–103."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "potter-screen-assists",
            replayAtMs: 156_000,
            clock: clock(4, "4th", "2:13"),
            kind: "stat",
            facts: [
                "Holmgren's three cut Indiana's lead to five at 3:21; Potter answered from three 24 seconds later on Nembhard's eleventh assist.",
                "Potter's fifth screen assist then created his twelfth point of the game at 2:13."
            ],
            sourceRefs: [
                "NBA play-by-play 4b26b9387408 actions 662–665",
                "NBA hustle c2946e0322b2",
                "NBA hustle c7938140c5d5"
            ]
        },
        {
            id: "sga-forty-three",
            replayAtMs: 163_857,
            clock: clock(4, "4th", "1:12"),
            kind: "milestone",
            facts: ["Gilgeous-Alexander completed a three-point play to reach 43 points and make it 113–110."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "sga-late-run",
            replayAtMs: 170_000,
            clock: clock(4, "4th", "24.3"),
            kind: "run",
            facts: ["Gilgeous-Alexander's layup gave him 45 points and cut the gap to one."],
            sourceRefs: ["NBA play-by-play", "NBA game recap"]
        },
        {
            id: "walker-clutch-free-throws",
            replayAtMs: 175_762,
            clock: clock(4, "4th", "10.3"),
            kind: "score",
            facts: ["Jarace Walker made two free throws to put Indiana ahead 115–112."],
            sourceRefs: ["NBA play-by-play"]
        },
        {
            id: "last-free-throw-exchange",
            replayAtMs: 177_531,
            clock: clock(4, "4th", "6.0"),
            kind: "score",
            facts: ["SGA reached 47 at the line before Walker answered with two free throws for his career-high 26."],
            sourceRefs: ["NBA play-by-play", "NBA box score"]
        },
        {
            id: "pacers-final",
            replayAtMs: 180_000,
            clock: clock(4, "Final", "0:00"),
            kind: "final",
            facts: [
                "Indiana won 117–114.",
                "Andrew Nembhard finished with 27 points and 11 assists.",
                "Jarace Walker scored a career-high 26 points.",
                "Shai Gilgeous-Alexander scored 47 points with only one turnover.",
                "Chet Holmgren had 25 points, 13 rebounds, three assists, three blocks and zero turnovers."
            ],
            sourceRefs: ["NBA box score", "NBA game recap", "X 2014905261727637827"]
        },
        {
            id: "regular-end-fourth",
            replayAtMs: 180_000,
            clock: clock(4, "End 4th", "0:00"),
            kind: "score",
            facts: ["The fourth-quarter horn confirmed Indiana's 117–114 win."],
            sourceRefs: ["NBA box score 5261fe267ff3", "NBA play-by-play 4b26b9387408"]
        }
    ],
    feedAssets: [
        {
            id: "rematch-open",
            revealAtMs: 0,
            kind: "welcome",
            evidenceIds: ["rematch-pregame"],
            presentation: {
                label: "Before tip",
                eyebrow: "Paycom Center · Coming up",
                headline: "A Finals rematch with something to prove",
                body: "Indiana and Oklahoma City meet again. Nembhard, Walker and Gilgeous-Alexander headline the players to watch.",
                image: "/media/social/x/2014855979242860742.jpg",
                imageAlt: "An Oklahoma City Thunder warm-up photo collage before tip.",
                source: regularSeasonSources.gettingReadyX
            }
        },
        {
            id: "regular-broadcast-context",
            revealAtMs: 0,
            kind: "insight",
            evidenceIds: ["regular-game-context"],
            presentation: {
                label: "Game guide",
                eyebrow: "Paycom Center · Oklahoma City",
                headline: "A rematch carrying memories from June",
                body: "The building, the uniforms and the stakes are different. The central question remains: can Indiana's collective control withstand Oklahoma City's star power?",
                stats: [
                    { value: "IND", label: "AWAY" },
                    { value: "OKC", label: "HOME" },
                    { value: "48 MIN", label: "REMATCH" }
                ]
            }
        },
        {
            id: "regular-roster-note",
            revealAtMs: 0,
            kind: "alert",
            evidenceIds: ["regular-availability"],
            presentation: {
                label: "Before tip",
                eyebrow: "Official pregame roster record",
                headline: "Indiana's creators will have to share the load",
                body: "Haliburton and Mathurin are listed inactive through injury. Nembhard, Siakam and Walker enter a Finals rematch with more of the offense in their hands.",
                accent: "#FDBB30"
            }
        },
        {
            id: "rematch-tip-live",
            revealAtMs: 4_000,
            kind: "welcome",
            evidenceIds: ["rematch-tip"],
            presentation: {
                label: "Game on",
                eyebrow: "1st · 12:00",
                headline: "The rematch starts at Paycom Center",
                body: "Indiana and Oklahoma City are underway. The next chapter begins with possession one."
            }
        },
        {
            id: "nembhard-sets-tone",
            revealAtMs: 12_800,
            kind: "insight",
            evidenceIds: ["nembhard-seven"],
            presentation: {
                label: "Early read",
                eyebrow: "8:42 · 1st",
                headline: "Nembhard is setting the pace",
                body: "Nembhard has seven of Indiana's first 11, scoring at the rim, in the midrange and from three. He is setting the terms early.",
                accent: "#FDBB30",
                stats: [
                    { value: "7", label: "PTS" },
                    { value: "11", label: "IND TOTAL" },
                    { value: "3", label: "SCORES" }
                ]
            }
        },
        {
            id: "nembhard-hot-hand",
            revealAtMs: 44_850,
            kind: "alert",
            evidenceIds: ["nembhard-sixteen"],
            presentation: {
                label: "Hot hand",
                eyebrow: "9:03 · 2nd",
                headline: "Three threes. Sixteen for Nembhard.",
                body: "His latest catch-and-shoot triple has pushed Indiana's lead to 17.",
                accent: "#FDBB30",
                storyteller: {
                    type: "clip",
                    clipId: "43b342b3-39dd-6228-f239-3a1effdc3132",
                    poster: "https://storyteller-assets.nba.com/assets/clips/43b342b3-39dd-6228-f239-3a1effdc3132/c1cdfc47-cbbe-dd2c-313d-3a1effdc3657/BestThumbnail.webp",
                    accessibleLabel: "Play Andrew Nembhard's third three-pointer"
                }
            }
        },
        {
            id: "pacers-fast-start",
            revealAtMs: 36_000,
            kind: "insight",
            evidenceIds: ["pacers-first-quarter"],
            presentation: {
                label: "End of 1st",
                eyebrow: "End 1st · Pacers 39–28",
                headline: "Indiana lands the first punch",
                body: "Thirty-nine points and an 11-point lead have forced the Thunder into chase mode early.",
                image: "/media/social/x/2014876797825884484.jpg",
                imageAlt: "T.J. McConnell banks in a baseline shot to beat the first-quarter buzzer.",
                video: "/media/social/x/2014876797825884484.mp4",
                videoPoster: "/media/social/x/2014876797825884484.jpg",
                mediaShape: "portrait",
                source: regularSeasonSources.firstQuarterX,
                accent: "#FDBB30",
                stats: [
                    { value: "39", label: "IND PTS" },
                    { value: "+11", label: "MARGIN" },
                    { value: "1", label: "QUARTER" }
                ],
                actionLabel: "Watch the buzzer-beater",
                durationLabel: "0:09"
            }
        },
        {
            id: "regular-second-quarter-live",
            revealAtMs: 37_000,
            kind: "welcome",
            evidenceIds: ["regular-second-quarter-open"],
            presentation: {
                label: "2nd quarter",
                eyebrow: "11:40 · Pacers 39–28",
                headline: "Indiana dictates the first-quarter pace",
                body: "Thirty-nine first-quarter points have forced Oklahoma City to chase. The Thunder's answer has to begin with the next defensive possession.",
                accent: "#FDBB30"
            }
        },
        {
            id: "walker-career-night",
            revealAtMs: 95_112,
            kind: "insight",
            evidenceIds: ["walker-fifteen"],
            presentation: {
                label: "Player watch",
                eyebrow: "5:04 · 3rd",
                headline: "Walker's career night is taking shape",
                body: "His third three takes him to 15 and restores Indiana's nine-point lead. Oklahoma City has narrowed the room for error.",
                accent: "#FDBB30",
                stats: [
                    { value: "15", label: "PTS" },
                    { value: "3", label: "3PM" },
                    { value: "+9", label: "IND" }
                ]
            }
        },
        {
            id: "sga-thirty-two-card",
            revealAtMs: 102_556,
            kind: "moment",
            evidenceIds: ["sga-thirty-two"],
            presentation: {
                label: "Star pressure",
                eyebrow: "2:50 · 3rd",
                headline: "SGA keeps bringing the chase back to Indiana",
                body: "His and-one first pulled Oklahoma City within three at 7:28. Now he has 32, and another drive has returned the game to the same one-possession pressure.",
                image: "/media/regular-season/sga-jumper.jpg",
                imageAlt: "Shai Gilgeous-Alexander rises for a jumper over Indiana.",
                accent: "#F05133"
            }
        },
        {
            id: "seventeen-becomes-seven",
            revealAtMs: 62_350,
            kind: "alert",
            evidenceIds: ["wallace-cuts-to-seven"],
            presentation: {
                label: "Run building",
                eyebrow: "3:13 · 2nd",
                headline: "Seventeen has become seven",
                body: "Wallace's three completes a 16–6 response. The building is awake, and Indiana's runaway start has become a contest.",
                accent: "#F05133",
                storyteller: {
                    type: "clip",
                    clipId: "2409c579-9716-64a1-5701-3a1effe9d0ba",
                    accessibleLabel: "Play Cason Wallace's three to complete Oklahoma City's response"
                }
            }
        },
        {
            id: "siakam-halftime",
            revealAtMs: 72_000,
            kind: "highlight",
            evidenceIds: ["halftime-close"],
            presentation: {
                label: "Halftime",
                eyebrow: "Halftime · Pacers 58–53",
                headline: "Indiana bends, but keeps the lead",
                body: "The Pacers led by 17 before Oklahoma City cut it to five. Siakam's bruising and-one captures the fight that kept Indiana ahead at the break.",
                image: "/media/social/siakam-and-one.jpg",
                imageAlt: "Pascal Siakam finishes through contact against Oklahoma City.",
                video: "/media/social/siakam-and-one.mp4",
                videoPoster: "/media/social/siakam-and-one.jpg",
                actionLabel: "Watch the and-one",
                durationLabel: "0:10"
            }
        },
        {
            id: "regular-second-quarter-score",
            revealAtMs: 72_000,
            kind: "insight",
            evidenceIds: ["regular-end-second"],
            presentation: {
                label: "End of 2nd",
                eyebrow: "Pacers 58 · Thunder 53",
                headline: "The Thunder cut seventeen to five",
                body: "Indiana's 17-point high-water mark is gone. A 25–19 Thunder quarter has changed the terms of the rematch before halftime.",
                accent: "#F05133",
                stats: [
                    { value: "25–19", label: "2ND QUARTER" },
                    { value: "5", label: "POINT GAME" },
                    { value: "17", label: "PEAK IND LEAD" }
                ]
            }
        },
        {
            id: "regular-third-quarter-live",
            revealAtMs: 73_111,
            kind: "welcome",
            evidenceIds: ["regular-third-quarter-open"],
            presentation: {
                label: "3rd quarter",
                eyebrow: "11:40 · Pacers 58–53",
                headline: "Control meets pressure after halftime",
                body: "Indiana still owns the lead. Oklahoma City owns the momentum. Nembhard's control and Gilgeous-Alexander's pressure meet in a five-point game.",
                accent: "#F05133"
            }
        },
        {
            id: "thunder-pressure",
            revealAtMs: 112_000,
            kind: "alert",
            evidenceIds: ["four-point-lead"],
            presentation: {
                label: "End of 3rd",
                eyebrow: "End 3rd · Pacers 89–85",
                headline: "Chet reaches one; Potter answers",
                body: "Holmgren's finish brings Oklahoma City within 86–85. Fifteen seconds later Potter buries a three, turning the Thunder's closest approach into a four-point Indiana lead.",
                accent: "#F05133"
            }
        },
        {
            id: "regular-fourth-quarter-live",
            revealAtMs: 113_465,
            kind: "welcome",
            evidenceIds: ["regular-fourth-quarter-open"],
            presentation: {
                label: "4th quarter",
                eyebrow: "11:40 · Pacers 89–85",
                headline: "Four points remain in the chase",
                body: "The Thunder have spent three quarters erasing Indiana's first punch. Four points remain, and every possession now carries the shape of the ending.",
                accent: "#F05133"
            }
        },
        {
            id: "regular-second-unit-lineup",
            revealAtMs: 112_000,
            kind: "insight",
            evidenceIds: ["regular-second-unit-five"],
            presentation: {
                label: "Lineup shift",
                eyebrow: "End 3rd · 2.5-minute stint",
                headline: "A perfect burst from Indiana's five",
                body: "This group scored on every field-goal attempt, assisted all five makes and gave the Pacers six points of separation.",
                accent: "#FDBB30",
                visual: nbaVisualFixtures.regularSecondUnitFive
            }
        },
        {
            id: "chet-closes-the-airspace",
            revealAtMs: 82_834,
            kind: "highlight",
            evidenceIds: ["chet-two-way-sequence"],
            presentation: {
                label: "Two-way sequence",
                eyebrow: "8:45 · 3rd · Pacers 63–60",
                headline: "Chet closes the airspace, then runs the floor",
                body: "Two blocks one second apart. Eighteen seconds later, Holmgren scores at the other end and turns a five-point game into one possession.",
                accent: "#F05133",
                stats: [
                    { value: "2", label: "BLOCKS" },
                    { value: "18 SEC", label: "BLOCK TO SCORE" },
                    { value: "3", label: "POINT GAME" }
                ]
            }
        },
        {
            id: "pacers-century",
            revealAtMs: 137_041,
            kind: "moment",
            evidenceIds: ["pacers-one-hundred"],
            presentation: {
                label: "Connection",
                eyebrow: "6:18 · 4th",
                headline: "Assist No. 10. Point No. 100.",
                body: "Nembhard finds Walker on the cut, and the dunk restores a nine-point Indiana lead.",
                accent: "#FDBB30",
                stats: [
                    { value: "10", label: "NEMBHARD AST" },
                    { value: "19", label: "WALKER PTS" },
                    { value: "100", label: "IND" }
                ],
                storyteller: {
                    type: "clip",
                    clipId: "fa8c74d2-a9ff-3f19-8f03-3a1f002866e7",
                    accessibleLabel: "Play Jarace Walker's dunk on Andrew Nembhard's tenth assist"
                }
            }
        },
        {
            id: "nembhard-big-shot",
            revealAtMs: 156_000,
            kind: "moment",
            evidenceIds: ["nembhard-three"],
            presentation: {
                label: "Big shot",
                eyebrow: "2:13 · 4th",
                headline: "Nembhard gives Indiana breathing room",
                body: "His fourth three of the night makes it a ten-point game and completes a 27-point, 11-assist performance.",
                accent: "#FDBB30",
                stats: [
                    { value: "27", label: "PTS" },
                    { value: "11", label: "AST" },
                    { value: "4", label: "3PM" }
                ]
            }
        },
        {
            id: "regular-potter-impact",
            revealAtMs: 156_000,
            kind: "insight",
            evidenceIds: ["potter-screen-assists"],
            presentation: {
                label: "Invisible work",
                eyebrow: "3:21–2:13 · 4th · Answer sequence",
                headline: "Chet asks. Potter answers.",
                body: "Holmgren's three cuts it to five; 24 seconds later Potter restores eight on Nembhard's 11th assist. Then his fifth screen assist opens Nembhard's path to a ten-point cushion.",
                accent: "#FDBB30",
                visual: nbaVisualFixtures.regularPotterImpact
            }
        },
        {
            id: "sga-three-point-play",
            revealAtMs: 163_857,
            kind: "moment",
            evidenceIds: ["sga-forty-three"],
            presentation: {
                label: "Clutch watch",
                eyebrow: "1:12 · 4th",
                headline: "SGA powers through for 43",
                body: "The layup and the foul make it a three-point game. Oklahoma City is not done.",
                accent: "#F05133",
                storyteller: {
                    type: "clip",
                    clipId: "43294d33-c800-3c9e-a6d6-3a1f003a64d1",
                    accessibleLabel: "Play Shai Gilgeous-Alexander's late three-point play"
                }
            }
        },
        {
            id: "sga-one-point",
            revealAtMs: 170_000,
            kind: "alert",
            evidenceIds: ["sga-late-run"],
            presentation: {
                label: "Clutch watch",
                eyebrow: "24.3 · 4th",
                headline: "SGA has made it a one-point game",
                body: "His layup gives him 45 and Oklahoma City one last chance to steal the game.",
                accent: "#F05133",
                stats: [
                    { value: "45", label: "PTS" },
                    { value: "7", label: "LAST 2 MIN" },
                    { value: "1", label: "POINT GAME" }
                ],
                storyteller: {
                    type: "clip",
                    clipId: "12c5ce72-0fac-3410-48d6-3a1f003ba064",
                    accessibleLabel: "Play Shai Gilgeous-Alexander's basket to cut the gap to one"
                }
            }
        },
        {
            id: "walker-at-the-line",
            revealAtMs: 175_762,
            kind: "alert",
            evidenceIds: ["walker-clutch-free-throws"],
            presentation: {
                label: "Pressure free throws",
                eyebrow: "10.3 · 4th",
                headline: "Walker makes both",
                body: "The 22-year-old calmly restores a three-point Indiana lead with the game on the line.",
                accent: "#FDBB30"
            }
        },
        {
            id: "final-free-throw-duel",
            revealAtMs: 177_531,
            kind: "moment",
            evidenceIds: ["last-free-throw-exchange"],
            presentation: {
                label: "Final exchange",
                eyebrow: "6.0 · 4th",
                headline: "Forty-seven for SGA. Career-high 26 for Walker.",
                body: "The stars trade pressure free throws. Indiana leads 117–114 with one final Thunder possession.",
                accent: "#FDBB30",
                stats: [
                    { value: "47", label: "SGA" },
                    { value: "26", label: "WALKER" },
                    { value: "6.0", label: "LEFT" }
                ]
            }
        },
        {
            id: "pacers-final-social",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["pacers-final"],
            presentation: {
                label: "From the Pacers",
                eyebrow: "Final · Pacers 117–114",
                headline: "Indiana leaves with the win",
                body: "A 117–114 road win closes the rematch after Indiana answers every late Thunder push.",
                image: "/media/social/x/2014905261727637827.jpg",
                imageAlt: "The Pacers' official social graphic celebrating a 117–114 win in Oklahoma City.",
                mediaShape: "portrait",
                source: regularSeasonSources.finalX,
                accent: "#FDBB30",
                stats: [
                    { value: "117–114", label: "FINAL" },
                    { value: "27 / 11", label: "NEMBHARD" },
                    { value: "26", label: "WALKER" }
                ],
                visual: nbaVisualFixtures.regularSgaApiInsight
            }
        },
        {
            id: "regular-photo-story",
            revealAtMs: 180_000,
            kind: "gallery",
            evidenceIds: ["pacers-final"],
            presentation: {
                label: "Photo story",
                eyebrow: "Final · 2 frames",
                headline: "The rematch in two frames",
                body: "Nembhard's command and Gilgeous-Alexander's 47-point reply tell the story of a game that reached its final possession.",
                accent: "#FDBB30",
                gallery: [
                    {
                        image: "/media/getty/0022500641/2257304568.jpg",
                        alt: "Andrew Nembhard drives against Oklahoma City during his 27-point, 11-assist game.",
                        source: regularSeasonSources.nembhard
                    },
                    {
                        image: "/media/getty/0022500641/2257317295.jpg",
                        alt: "Shai Gilgeous-Alexander attacks the Pacers defense during his 47-point night.",
                        source: regularSeasonSources.gilgeousAlexander
                    }
                ]
            }
        },
        {
            id: "pacers-recap",
            revealAtMs: 180_000,
            kind: "recap",
            evidenceIds: ["pacers-final"],
            presentation: {
                label: "Final",
                eyebrow: "Pacers 117 · Thunder 114",
                headline: "Indiana withstands a 47-point storm",
                body: "Nembhard conducted with 27 points and 11 assists; Walker closed with a career-high 26. Gilgeous-Alexander's losing brilliance reached 47, while Holmgren added 25 points, 13 rebounds, three assists, three blocks and no turnovers.",
                storyteller: {
                    type: "story",
                    storyId: "2fe80541-942f-95f0-9bc9-3a1efc00452b",
                    poster: "https://storyteller-assets.nba.com/assets/studio-templates/2fe80541-942f-95f0-9bc9-3a1efc00452b/9a14f0e9-7982-438c-a90b-4f7ddd04963b/58402d37-6f4e-aa9e-4d31-3a1f007cccc4/thumbnail_small.jpeg",
                    pageCount: 27,
                    actionLabel: "Go all-access",
                    accessibleLabel: "Open the 27-frame Pacers versus Thunder all-access story"
                },
                stats: [
                    { value: "27", label: "NEMBHARD" },
                    { value: "26", label: "WALKER" },
                    { value: "47", label: "SGA" }
                ]
            }
        },
        {
            id: "regular-fourth-quarter-score",
            revealAtMs: 180_000,
            kind: "insight",
            evidenceIds: ["regular-end-fourth"],
            presentation: {
                label: "End of 4th",
                eyebrow: "Pacers 117 · Thunder 114",
                headline: "Indiana answers every late question",
                body: "Chet to one, Potter to four. Chet to five, Potter to eight. SGA to one, Walker at the line. Indiana answered every Thunder question and survived the last possession.",
                accent: "#FDBB30",
                visual: nbaVisualFixtures.regularOnePossessionFlow,
                stats: [
                    { value: "28–29", label: "4TH QUARTER" },
                    { value: "3", label: "FINAL MARGIN" },
                    { value: "1", label: "LAST POSSESSION" }
                ]
            }
        }
    ]
};
